const phraseTranslations = {
  'Student Career Dashboard | Potho Prodorshok': { hi: 'छात्र करियर डैशबोर्ड | Potho Prodorshok', bn: 'শিক্ষার্থী ক্যারিয়ার ড্যাশবোর্ড | Potho Prodorshok' },
  'Track roadmaps, mock tests, weak topics, saved questions, scholarships, and next actions in your AI career workspace.': {
    hi: 'अपने AI करियर वर्कस्पेस में रोडमैप, मॉक टेस्ट, कमजोर विषय, सेव प्रश्न, छात्रवृत्तियां और अगले कदम ट्रैक करें।',
    bn: 'আপনার AI ক্যারিয়ার ওয়ার্কস্পেসে রোডম্যাপ, মক টেস্ট, দুর্বল বিষয়, সংরক্ষিত প্রশ্ন, স্কলারশিপ এবং পরবর্তী কাজ ট্র্যাক করুন।',
  },
  'AI Career Roadmap Planner | Potho Prodorshok': { hi: 'AI करियर रोडमैप प्लानर | Potho Prodorshok', bn: 'AI ক্যারিয়ার রোডম্যাপ প্ল্যানার | Potho Prodorshok' },
  'Generate and save personalized career roadmaps from your skills, interests, exam goals, and student profile.': {
    hi: 'अपने कौशल, रुचि, परीक्षा लक्ष्यों और छात्र प्रोफाइल से व्यक्तिगत करियर रोडमैप बनाएं और सेव करें।',
    bn: 'আপনার দক্ষতা, আগ্রহ, পরীক্ষার লক্ষ্য এবং শিক্ষার্থী প্রোফাইল থেকে ব্যক্তিগত ক্যারিয়ার রোডম্যাপ তৈরি ও সংরক্ষণ করুন।',
  },
  'AI Tutor and Mock Tests | Potho Prodorshok': { hi: 'AI ट्यूटर और मॉक टेस्ट | Potho Prodorshok', bn: 'AI টিউটর ও মক টেস্ট | Potho Prodorshok' },
  'Practice exam questions, review mistakes, take mock tests, and get AI explanations for competitive exam preparation.': {
    hi: 'प्रतियोगी परीक्षा तैयारी के लिए प्रश्न अभ्यास करें, गलतियां रिव्यू करें, मॉक टेस्ट दें और AI व्याख्या पाएं।',
    bn: 'প্রতিযোগিতামূলক পরীক্ষার প্রস্তুতির জন্য প্রশ্ন অনুশীলন করুন, ভুল রিভিউ করুন, মক টেস্ট দিন এবং AI ব্যাখ্যা পান।',
  },
  'Scholarship Eligibility Finder | Potho Prodorshok': { hi: 'छात्रवृत्ति पात्रता फाइंडर | Potho Prodorshok', bn: 'স্কলারশিপ যোগ্যতা ফাইন্ডার | Potho Prodorshok' },
  'Scholarship Eligibility Finder | Potho-Prodorshok': { hi: 'छात्रवृत्ति पात्रता फाइंडर | Potho-Prodorshok', bn: 'স্কলারশিপ যোগ্যতা ফাইন্ডার | Potho-Prodorshok' },
  'Match scholarships by course, income, marks, gender, category, documents, deadlines, and application readiness.': {
    hi: 'कोर्स, आय, अंक, लिंग, श्रेणी, दस्तावेज, अंतिम तिथि और आवेदन तैयारी के आधार पर छात्रवृत्तियां मिलाएं।',
    bn: 'কোর্স, আয়, নম্বর, লিঙ্গ, বিভাগ, ডকুমেন্ট, ডেডলাইন এবং আবেদন প্রস্তুতি অনুযায়ী স্কলারশিপ মিলান।',
  },
  'Saved Learning Library | Potho Prodorshok': { hi: 'सेव लर्निंग लाइब्रेरी | Potho Prodorshok', bn: 'সংরক্ষিত লার্নিং লাইব্রেরি | Potho Prodorshok' },
  'Open saved roadmaps, questions, mock tests, scholarships, chats, mistakes, and study resources in one place.': {
    hi: 'सेव रोडमैप, प्रश्न, मॉक टेस्ट, छात्रवृत्ति, चैट, गलतियां और अध्ययन संसाधन एक जगह खोलें।',
    bn: 'সংরক্ষিত রোডম্যাপ, প্রশ্ন, মক টেস্ট, স্কলারশিপ, চ্যাট, ভুল এবং স্টাডি রিসোর্স এক জায়গায় খুলুন।',
  },
  'Student Profile Settings | Potho Prodorshok': { hi: 'छात्र प्रोफाइल सेटिंग्स | Potho Prodorshok', bn: 'শিক্ষার্থী প্রোফাইল সেটিংস | Potho Prodorshok' },
  'Manage the profile context used for AI roadmaps, tutoring, scholarships, recommendations, and saved progress.': {
    hi: 'AI रोडमैप, ट्यूटरिंग, छात्रवृत्ति, सुझाव और सेव प्रगति में इस्तेमाल होने वाला प्रोफाइल संदर्भ मैनेज करें।',
    bn: 'AI রোডম্যাপ, টিউটরিং, স্কলারশিপ, সুপারিশ এবং সংরক্ষিত অগ্রগতির জন্য ব্যবহৃত প্রোফাইল প্রসঙ্গ পরিচালনা করুন।',
  },
  'Potho Prodorshok | AI Career OS for Students': { hi: 'Potho Prodorshok | छात्रों के लिए AI करियर OS', bn: 'Potho Prodorshok | শিক্ষার্থীদের জন্য AI ক্যারিয়ার OS' },
  'Plan careers, practice exams, find scholarships, save progress, and get AI-guided next actions for students in India.': {
    hi: 'भारत के छात्रों के लिए करियर प्लान करें, परीक्षा अभ्यास करें, छात्रवृत्ति खोजें, प्रगति सेव करें और AI-निर्देशित अगले कदम पाएं।',
    bn: 'ভারতের শিক্ষার্থীদের জন্য ক্যারিয়ার পরিকল্পনা, পরীক্ষা অনুশীলন, স্কলারশিপ খোঁজা, অগ্রগতি সংরক্ষণ এবং AI-নির্দেশিত পরবর্তী কাজ পান।',
  },
  'Privacy Policy and Terms for Potho-Prodorshok Career OS.': { hi: 'Potho-Prodorshok Career OS की गोपनीयता नीति और शर्तें।', bn: 'Potho-Prodorshok Career OS-এর প্রাইভেসি পলিসি ও শর্তাবলি।' },
  'This page explains how Potho-Prodorshok handles account data, student workspace data, AI-generated content, and acceptable use.': {
    hi: 'यह पेज बताता है कि Potho-Prodorshok खाता डेटा, छात्र वर्कस्पेस डेटा, AI-जनरेटेड कंटेंट और स्वीकार्य उपयोग को कैसे संभालता है।',
    bn: 'এই পেজে ব্যাখ্যা করা হয়েছে Potho-Prodorshok কীভাবে অ্যাকাউন্ট ডেটা, শিক্ষার্থী ওয়ার্কস্পেস ডেটা, AI-তৈরি কনটেন্ট এবং গ্রহণযোগ্য ব্যবহার সামলায়।',
  },
  'We collect account information such as email address, password hash, Google OAuth identifier when used, and session data needed to keep users signed in.': {
    hi: 'हम ईमेल पता, पासवर्ड हैश, उपयोग होने पर Google OAuth पहचान, और उपयोगकर्ताओं को साइन इन रखने के लिए जरूरी सत्र डेटा जैसी खाता जानकारी एकत्र करते हैं।',
    bn: 'আমরা ইমেল ঠিকানা, পাসওয়ার্ড হ্যাশ, ব্যবহার করা হলে Google OAuth পরিচয়, এবং ব্যবহারকারীকে সাইন ইন রাখতে প্রয়োজনীয় সেশন ডেটার মতো অ্যাকাউন্ট তথ্য সংগ্রহ করি।',
  },
  'We do not sell personal information. Data is used to operate and improve the product experience.': {
    hi: 'हम व्यक्तिगत जानकारी नहीं बेचते। डेटा का उपयोग उत्पाद अनुभव चलाने और बेहतर बनाने के लिए किया जाता है।',
    bn: 'আমরা ব্যক্তিগত তথ্য বিক্রি করি না। ডেটা পণ্য অভিজ্ঞতা চালানো এবং উন্নত করার জন্য ব্যবহৃত হয়।',
  },
  'Users can delete chat sessions, saved questions, archive roadmaps, and update scholarship tracker states from the app where supported.': {
    hi: 'जहां सुविधा उपलब्ध है, उपयोगकर्ता ऐप से चैट सत्र डिलीट कर सकते हैं, सेव प्रश्न हटा सकते हैं, रोडमैप आर्काइव कर सकते हैं और छात्रवृत्ति ट्रैकर स्थिति अपडेट कर सकते हैं।',
    bn: 'যেখানে সুবিধা আছে, ব্যবহারকারীরা অ্যাপ থেকে চ্যাট সেশন মুছতে, সংরক্ষিত প্রশ্ন মুছতে, রোডম্যাপ আর্কাইভ করতে এবং স্কলারশিপ ট্র্যাকার অবস্থা আপডেট করতে পারেন।',
  },
  'The service is intended for educational guidance, career planning, and study support. Users must not misuse the app, attempt to disrupt service, or upload unlawful content.': {
    hi: 'यह सेवा शैक्षिक मार्गदर्शन, करियर प्लानिंग और अध्ययन सहायता के लिए है। उपयोगकर्ता ऐप का दुरुपयोग, सेवा बाधित करने का प्रयास, या अवैध कंटेंट अपलोड नहीं कर सकते।',
    bn: 'এই পরিষেবাটি শিক্ষাগত নির্দেশনা, ক্যারিয়ার পরিকল্পনা এবং পড়াশোনার সহায়তার জন্য। ব্যবহারকারীরা অ্যাপের অপব্যবহার, পরিষেবা বিঘ্নিত করার চেষ্টা, বা বেআইনি কনটেন্ট আপলোড করতে পারবেন না।',
  },
  'AI-generated advice is informational and is not a substitute for professional counselling, official exam notices, official scholarship rules, or institutional guidance.': {
    hi: 'AI-जनरेटेड सलाह जानकारी के लिए है और यह पेशेवर काउंसलिंग, आधिकारिक परीक्षा नोटिस, आधिकारिक छात्रवृत्ति नियम या संस्थागत मार्गदर्शन का विकल्प नहीं है।',
    bn: 'AI-তৈরি পরামর্শ তথ্যভিত্তিক এবং এটি পেশাদার কাউন্সেলিং, অফিসিয়াল পরীক্ষা নোটিস, অফিসিয়াল স্কলারশিপ নিয়ম বা প্রতিষ্ঠানের নির্দেশনার বিকল্প নয়।',
  },
  'The app is provided as a student project/product prototype and may change over time as features are improved.': {
    hi: 'यह ऐप छात्र प्रोजेक्ट/उत्पाद प्रोटोटाइप के रूप में दिया गया है और फीचर बेहतर होने के साथ समय के साथ बदल सकता है।',
    bn: 'এই অ্যাপটি শিক্ষার্থী প্রজেক্ট/পণ্য প্রোটোটাইপ হিসেবে দেওয়া হয়েছে এবং ফিচার উন্নত হওয়ার সঙ্গে সময়ের সাথে বদলাতে পারে।',
  },
  'Copied!': { hi: 'कॉपी हो गया!', bn: 'কপি হয়েছে!' },
  'Guest workspace': { hi: 'अतिथि कार्यक्षेत्र', bn: 'অতিথি কর্মক্ষেত্র' },
  'Guest limit': { hi: 'अतिथि सीमा', bn: 'অতিথি সীমা' },
  'Create an account to save this workspace': { hi: 'इस कार्यक्षेत्र को सेव करने के लिए खाता बनाएं', bn: 'এই কর্মক্ষেত্রটি সংরক্ষণ করতে একটি অ্যাকাউন্ট তৈরি করুন' },
  'Guest mode is for exploring the product. Saved roadmaps, profile memory, library, mock history, and long-term analytics need a real account.': {
    hi: 'अतिथि मोड उत्पाद को देखने के लिए है। सेव रोडमैप, प्रोफाइल मेमोरी, लाइब्रेरी, मॉक हिस्ट्री और लंबी अवधि के एनालिटिक्स के लिए असली खाता चाहिए।',
    bn: 'অতিথি মোড পণ্যটি ঘুরে দেখার জন্য। সংরক্ষিত রোডম্যাপ, প্রোফাইল মেমরি, লাইব্রেরি, মক ইতিহাস এবং দীর্ঘমেয়াদি অ্যানালিটিক্সের জন্য আসল অ্যাকাউন্ট দরকার।',
  },
  'Create free account': { hi: 'मुफ्त खाता बनाएं', bn: 'বিনামূল্যে অ্যাকাউন্ট তৈরি করুন' },
  'Back to guest dashboard': { hi: 'अतिथि डैशबोर्ड पर वापस जाएं', bn: 'অতিথি ড্যাশবোর্ডে ফিরুন' },
  'Loading...': { hi: 'लोड हो रहा है...', bn: 'লোড হচ্ছে...' },
  'Career OS': { hi: 'करियर OS', bn: 'ক্যারিয়ার OS' },
  'Search roadmaps, topics, scholarships...': { hi: 'रोडमैप, विषय, छात्रवृत्ति खोजें...', bn: 'রোডম্যাপ, বিষয়, স্কলারশিপ খুঁজুন...' },
  'Search roadmaps, saved questions, chats, scholarships...': { hi: 'रोडमैप, सेव प्रश्न, चैट, छात्रवृत्ति खोजें...', bn: 'রোডম্যাপ, সংরক্ষিত প্রশ্ন, চ্যাট, স্কলারশিপ খুঁজুন...' },
  'Guest mode': { hi: 'अतिथि मोड', bn: 'অতিথি মোড' },
  'Signed in': { hi: 'साइन इन है', bn: 'সাইন ইন করা আছে' },
  'Active user': { hi: 'सक्रिय उपयोगकर्ता', bn: 'সক্রিয় ব্যবহারকারী' },
  'Guest preview workspace': { hi: 'अतिथि पूर्वावलोकन कार्यक्षेत्र', bn: 'অতিথি প্রিভিউ কর্মক্ষেত্র' },
  'Signed in workspace': { hi: 'साइन-इन कार्यक्षेत्र', bn: 'সাইন-ইন কর্মক্ষেত্র' },
  'Save workspace': { hi: 'कार्यस्थान सेव करें', bn: 'কর্মক্ষেত্র সংরক্ষণ করুন' },
  'Exit guest mode': { hi: 'अतिथि मोड से बाहर निकलें', bn: 'অতিথি মোড থেকে বের হন' },
  'Workspace': { hi: 'कार्यस्थान', bn: 'কর্মক্ষেত্র' },
  'Command Center': { hi: 'कमांड सेंटर', bn: 'কমান্ড সেন্টার' },
  'Session': { hi: 'सत्र', bn: 'সেশন' },
  'Save this workspace': { hi: 'यह कार्यक्षेत्र सेव करें', bn: 'এই কর্মক্ষেত্র সংরক্ষণ করুন' },
  'Type at least two characters to search your workspace.': { hi: 'अपने कार्यक्षेत्र में खोजने के लिए कम से कम दो अक्षर लिखें।', bn: 'আপনার কর্মক্ষেত্রে খুঁজতে কমপক্ষে দুই অক্ষর লিখুন।' },
  'No results yet.': { hi: 'अभी कोई परिणाम नहीं।', bn: 'এখনও কোনো ফল নেই।' },
  'Open dashboard': { hi: 'डैशबोर्ड खोलें', bn: 'ড্যাশবোর্ড খুলুন' },
  'Open command search': { hi: 'कमांड खोज खोलें', bn: 'কমান্ড সার্চ খুলুন' },
  'Close command search': { hi: 'कमांड खोज बंद करें', bn: 'কমান্ড সার্চ বন্ধ করুন' },
  'Open menu': { hi: 'मेन्यू खोलें', bn: 'মেনু খুলুন' },
  'Close menu': { hi: 'मेन्यू बंद करें', bn: 'মেনু বন্ধ করুন' },
  'Go to landing page': { hi: 'लैंडिंग पेज पर जाएं', bn: 'ল্যান্ডিং পেজে যান' },
  'Toggle theme': { hi: 'थीम बदलें', bn: 'থিম বদলান' },

  Home: { hi: 'होम', bn: 'হোম' },
  Funds: { hi: 'फंड', bn: 'ফান্ড' },
  Library: { hi: 'लाइब्रेरी', bn: 'লাইব্রেরি' },
  Profile: { hi: 'प्रोफाइल', bn: 'প্রোফাইল' },
  Dashboard: { hi: 'डैशबोर्ड', bn: 'ড্যাশবোর্ড' },
  Team: { hi: 'टीम', bn: 'টিম' },
  Support: { hi: 'सहायता', bn: 'সাপোর্ট' },
  Policies: { hi: 'नीतियां', bn: 'নীতি' },

  'Back to landing': { hi: 'लैंडिंग पर वापस', bn: 'ল্যান্ডিংয়ে ফিরুন' },
  Back: { hi: 'वापस', bn: 'ফিরুন' },
  'Welcome back': { hi: 'फिर से स्वागत है', bn: 'আবার স্বাগতম' },
  'Start planning': { hi: 'योजना शुरू करें', bn: 'পরিকল্পনা শুরু করুন' },
  'Log in': { hi: 'लॉग इन', bn: 'লগ ইন' },
  Login: { hi: 'लॉग इन', bn: 'লগ ইন' },
  'Create Account': { hi: 'खाता बनाएं', bn: 'অ্যাকাউন্ট তৈরি করুন' },
  'Create account': { hi: 'खाता बनाएं', bn: 'অ্যাকাউন্ট তৈরি করুন' },
  'Continue your AI-guided career path.': { hi: 'अपना AI-निर्देशित करियर पथ जारी रखें।', bn: 'আপনার AI-নির্দেশিত ক্যারিয়ার পথ চালিয়ে যান।' },
  'Your journey to a future-proof career.': { hi: 'भविष्य-तैयार करियर की आपकी यात्रा।', bn: 'ভবিষ্যৎ-প্রস্তুত ক্যারিয়ারের পথে আপনার যাত্রা।' },
  'Return to saved roadmaps, tutor chats, mock tests, and scholarship matches.': {
    hi: 'सेव रोडमैप, ट्यूटर चैट, मॉक टेस्ट और छात्रवृत्ति मैच पर वापस जाएं।',
    bn: 'সংরক্ষিত রোডম্যাপ, টিউটর চ্যাট, মক টেস্ট এবং স্কলারশিপ ম্যাচে ফিরুন।',
  },
  'Join learners using AI roadmaps, tutoring, and scholarship discovery to plan with clarity.': {
    hi: 'स्पष्ट योजना के लिए AI रोडमैप, ट्यूटरिंग और छात्रवृत्ति खोज का उपयोग करने वाले छात्रों से जुड़ें।',
    bn: 'পরিষ্কার পরিকল্পনার জন্য AI রোডম্যাপ, টিউটরিং এবং স্কলারশিপ অনুসন্ধান ব্যবহার করা শিক্ষার্থীদের সঙ্গে যোগ দিন।',
  },
  'Access your dashboard and keep moving toward the next milestone.': {
    hi: 'अपना डैशबोर्ड खोलें और अगले लक्ष्य की ओर बढ़ते रहें।',
    bn: 'আপনার ড্যাশবোর্ড খুলুন এবং পরবর্তী মাইলস্টোনের দিকে এগিয়ে যান।',
  },
  'Create your account to unlock the dashboard, saved sessions, and AI-generated guidance.': {
    hi: 'डैशबोर्ड, सेव सत्र और AI-जनरेटेड मार्गदर्शन खोलने के लिए खाता बनाएं।',
    bn: 'ড্যাশবোর্ড, সংরক্ষিত সেশন এবং AI-তৈরি নির্দেশনা আনলক করতে অ্যাকাউন্ট তৈরি করুন।',
  },
  'Email Address': { hi: 'ईमेल पता', bn: 'ইমেল ঠিকানা' },
  Password: { hi: 'पासवर्ड', bn: 'পাসওয়ার্ড' },
  'Hide password': { hi: 'पासवर्ड छिपाएं', bn: 'পাসওয়ার্ড লুকান' },
  'Show password': { hi: 'पासवर्ड दिखाएं', bn: 'পাসওয়ার্ড দেখান' },
  'Logging in...': { hi: 'लॉग इन हो रहा है...', bn: 'লগ ইন হচ্ছে...' },
  'Creating account...': { hi: 'खाता बन रहा है...', bn: 'অ্যাকাউন্ট তৈরি হচ্ছে...' },
  or: { hi: 'या', bn: 'অথবা' },
  'Sign in with Google': { hi: 'Google से साइन इन करें', bn: 'Google দিয়ে সাইন ইন করুন' },
  'Sign up with Google': { hi: 'Google से साइन अप करें', bn: 'Google দিয়ে সাইন আপ করুন' },
  'New here?': { hi: 'यहां नए हैं?', bn: 'এখানে নতুন?' },
  'Create an account': { hi: 'खाता बनाएं', bn: 'অ্যাকাউন্ট তৈরি করুন' },
  'Already have an account?': { hi: 'पहले से खाता है?', bn: 'আগেই অ্যাকাউন্ট আছে?' },
  'Success!': { hi: 'सफल!', bn: 'সফল!' },
  Close: { hi: 'बंद करें', bn: 'বন্ধ করুন' },
  'Google sign-in was not authorized. Please try again.': { hi: 'Google साइन-इन अधिकृत नहीं हुआ। कृपया फिर कोशिश करें।', bn: 'Google সাইন-ইন অনুমোদিত হয়নি। আবার চেষ্টা করুন।' },
  'Failed to get your information from Google.': { hi: 'Google से आपकी जानकारी नहीं मिल सकी।', bn: 'Google থেকে আপনার তথ্য পাওয়া যায়নি।' },
  'Google did not provide required information.': { hi: 'Google ने जरूरी जानकारी नहीं दी।', bn: 'Google প্রয়োজনীয় তথ্য দেয়নি।' },
  'An error occurred during sign-in. Please try again.': { hi: 'साइन-इन के दौरान त्रुटि हुई। फिर कोशिश करें।', bn: 'সাইন-ইনের সময় সমস্যা হয়েছে। আবার চেষ্টা করুন।' },
  'Google sign-in failed. Please try again.': { hi: 'Google साइन-इन विफल हुआ। फिर कोशिश करें।', bn: 'Google সাইন-ইন ব্যর্থ হয়েছে। আবার চেষ্টা করুন।' },
  'Login failed': { hi: 'लॉगिन विफल', bn: 'লগইন ব্যর্থ' },
  'Signup failed': { hi: 'साइनअप विफल', bn: 'সাইনআপ ব্যর্থ' },

  'Profile & Settings': { hi: 'प्रोफाइल और सेटिंग्स', bn: 'প্রোফাইল ও সেটিংস' },
  'Your student context': { hi: 'आपका छात्र संदर्भ', bn: 'আপনার শিক্ষার্থী প্রোফাইল' },
  'Keep this updated so roadmaps, questions, scholarships, and recommendations become more personal.': {
    hi: 'इसे अपडेट रखें ताकि रोडमैप, प्रश्न, छात्रवृत्ति और सुझाव अधिक व्यक्तिगत हों।',
    bn: 'এটি আপডেট রাখুন যাতে রোডম্যাপ, প্রশ্ন, স্কলারশিপ এবং সুপারিশ আরও ব্যক্তিগত হয়।',
  },
  'Current status': { hi: 'वर्तमान स्थिति', bn: 'বর্তমান অবস্থা' },
  Education: { hi: 'शिक्षा', bn: 'শিক্ষা' },
  'Preferred language': { hi: 'पसंदीदा भाषा', bn: 'পছন্দের ভাষা' },
  'Target exams': { hi: 'लक्षित परीक्षा', bn: 'লক্ষ্য পরীক্ষা' },
  'Exam branch or department': { hi: 'परीक्षा शाखा या विभाग', bn: 'পরীক্ষার শাখা বা বিভাগ' },
  'Select branch': { hi: 'शाखा चुनें', bn: 'শাখা নির্বাচন করুন' },
  'Preferred subjects': { hi: 'पसंदीदा विषय', bn: 'পছন্দের বিষয়' },
  Region: { hi: 'क्षेत्र', bn: 'অঞ্চল' },
  'Annual family income': { hi: 'वार्षिक पारिवारिक आय', bn: 'বার্ষিক পারিবারিক আয়' },
  'Scholarship eligibility profile': { hi: 'छात्रवृत्ति पात्रता प्रोफाइल', bn: 'স্কলারশিপ যোগ্যতা প্রোফাইল' },
  'Used by the scholarship match desk so students do not re-enter the same details.': {
    hi: 'इसे छात्रवृत्ति मैच डेस्क उपयोग करता है ताकि छात्रों को वही विवरण फिर न भरना पड़े।',
    bn: 'স্কলারশিপ ম্যাচ ডেস্ক এটি ব্যবহার করে যাতে শিক্ষার্থীদের একই তথ্য আবার দিতে না হয়।',
  },
  docs: { hi: 'दस्तावेज़', bn: 'ডকস' },
  'Studying as': { hi: 'छात्र प्रकार', bn: 'শিক্ষার্থী ধরন' },
  'Select student type': { hi: 'छात्र प्रकार चुनें', bn: 'শিক্ষার্থী ধরন নির্বাচন করুন' },
  'Course / stream': { hi: 'कोर्स / स्ट्रीम', bn: 'কোর্স / স্ট্রিম' },
  'Institution / college': { hi: 'संस्थान / कॉलेज', bn: 'প্রতিষ্ঠান / কলেজ' },
  'Institute / college': { hi: 'संस्थान / कॉलेज', bn: 'প্রতিষ্ঠান / কলেজ' },
  'Study destination': { hi: 'अध्ययन गंतव्य', bn: 'পড়াশোনার গন্তব্য' },
  Marks: { hi: 'अंक', bn: 'নম্বর' },
  Percentage: { hi: 'प्रतिशत', bn: 'শতাংশ' },
  CGPA: { hi: 'CGPA', bn: 'CGPA' },
  'Do not type %, /10, or words. Choose the mode above.': { hi: '%, /10 या शब्द न लिखें। ऊपर मोड चुनें।', bn: '%, /10 বা শব্দ লিখবেন না। উপরে মোড নির্বাচন করুন।' },
  'Religion / minority status': { hi: 'धर्म / अल्पसंख्यक स्थिति', bn: 'ধর্ম / সংখ্যালঘু অবস্থা' },
  Gender: { hi: 'लिंग', bn: 'লিঙ্গ' },
  Category: { hi: 'श्रेणी', bn: 'বিভাগ' },
  'Disability status': { hi: 'दिव्यांगता स्थिति', bn: 'প্রতিবন্ধকতার অবস্থা' },
  'Study level': { hi: 'अध्ययन स्तर', bn: 'পড়াশোনার স্তর' },
  'Documents ready': { hi: 'तैयार दस्तावेज़', bn: 'প্রস্তুত ডকুমেন্ট' },
  Skills: { hi: 'कौशल', bn: 'দক্ষতা' },
  Interests: { hi: 'रुचियां', bn: 'আগ্রহ' },
  'Career goals': { hi: 'करियर लक्ष्य', bn: 'ক্যারিয়ার লক্ষ্য' },
  'Target companies or institutions': { hi: 'लक्षित कंपनियां या संस्थान', bn: 'লক্ষ্য কোম্পানি বা প্রতিষ্ঠান' },
  'Save profile': { hi: 'प्रोफाइल सेव करें', bn: 'প্রোফাইল সংরক্ষণ করুন' },
  'Saving...': { hi: 'सेव हो रहा है...', bn: 'সংরক্ষণ হচ্ছে...' },
  Saved: { hi: 'सेव हो गया', bn: 'সংরক্ষিত' },
  Account: { hi: 'खाता', bn: 'অ্যাকাউন্ট' },
  Personalization: { hi: 'व्यक्तिगतकरण', bn: 'ব্যক্তিগতকরণ' },
  'Planner inputs can sync back into this profile, and future dashboards use it to suggest better next actions.': {
    hi: 'प्लानर इनपुट इस प्रोफाइल में सिंक हो सकते हैं, और आगे के डैशबोर्ड बेहतर अगले कदम सुझाने के लिए इसका उपयोग करते हैं।',
    bn: 'প্ল্যানারের ইনপুট এই প্রোফাইলে সিঙ্ক হতে পারে, আর ভবিষ্যৎ ড্যাশবোর্ড ভালো পরবর্তী কাজ সাজেস্ট করতে এটি ব্যবহার করে।',
  },
  'Profile could not load.': { hi: 'प्रोफाइल लोड नहीं हो सकी।', bn: 'প্রোফাইল লোড করা যায়নি।' },
  'Profile saved.': { hi: 'प्रोफाइल सेव हो गई।', bn: 'প্রোফাইল সংরক্ষিত হয়েছে।' },
  'Profile could not be saved.': { hi: 'प्रोफाइल सेव नहीं हो सकी।', bn: 'প্রোফাইল সংরক্ষণ করা যায়নি।' },

  'Scholarship match desk': { hi: 'छात्रवृत्ति मैच डेस्क', bn: 'স্কলারশিপ ম্যাচ ডেস্ক' },
  'Eligibility engine': { hi: 'पात्रता इंजन', bn: 'যোগ্যতা ইঞ্জিন' },
  'See how strongly each scholarship fits you, what amount it may provide, what documents are missing, and when the form closes.': {
    hi: 'देखें कौन सी छात्रवृत्ति आपसे कितनी मेल खाती है, राशि कितनी हो सकती है, कौन से दस्तावेज़ कम हैं और फॉर्म कब बंद होगा।',
    bn: 'প্রতিটি স্কলারশিপ আপনার সঙ্গে কতটা মেলে, কত টাকা দিতে পারে, কোন ডকুমেন্ট নেই এবং ফর্ম কবে বন্ধ হবে তা দেখুন।',
  },
  'Student fit profile': { hi: 'छात्र फिट प्रोफाइल', bn: 'শিক্ষার্থী ফিট প্রোফাইল' },
  'Edit eligibility filters': { hi: 'पात्रता फिल्टर संपादित करें', bn: 'যোগ্যতা ফিল্টার সম্পাদনা করুন' },
  'Hide filters and focus results': { hi: 'फिल्टर छिपाएं और परिणाम देखें', bn: 'ফিল্টার লুকিয়ে ফলাফলে ফোকাস করুন' },
  'Find eligible scholarships': { hi: 'योग्य छात्रवृत्तियां खोजें', bn: 'যোগ্য স্কলারশিপ খুঁজুন' },
  'Checking eligibility...': { hi: 'पात्रता जांची जा रही है...', bn: 'যোগ্যতা যাচাই হচ্ছে...' },
  'Why this is different': { hi: 'यह अलग क्यों है', bn: 'এটি আলাদা কেন' },
  'Match score explains fit instead of only showing links.': { hi: 'सिर्फ लिंक दिखाने के बजाय मैच स्कोर फिट समझाता है।', bn: 'শুধু লিংক দেখানোর বদলে ম্যাচ স্কোর ফিট ব্যাখ্যা করে।' },
  'Missing documents are separated before students apply.': { hi: 'आवेदन से पहले कम दस्तावेज़ अलग दिखते हैं।', bn: 'আবেদনের আগে অনুপস্থিত ডকুমেন্ট আলাদা করে দেখানো হয়।' },
  'Deadline urgency is visible on every card.': { hi: 'हर कार्ड पर डेडलाइन की तात्कालिकता दिखती है।', bn: 'প্রতিটি কার্ডে ডেডলাইনের জরুরি অবস্থা দেখা যায়।' },
  Amount: { hi: 'राशि', bn: 'পরিমাণ' },
  'Amount not confirmed': { hi: 'राशि पुष्टि नहीं हुई', bn: 'পরিমাণ নিশ্চিত নয়' },
  'Check deadline': { hi: 'डेडलाइन जांचें', bn: 'ডেডলাইন দেখুন' },
  'Check official notice': { hi: 'आधिकारिक नोटिस देखें', bn: 'অফিশিয়াল নোটিশ দেখুন' },
  'Matched reasons': { hi: 'मिलान के कारण', bn: 'ম্যাচের কারণ' },
  'Official': { hi: 'आधिकारिक', bn: 'অফিশিয়াল' },
  Save: { hi: 'सेव करें', bn: 'সংরক্ষণ' },
  Notify: { hi: 'सूचित करें', bn: 'নোটিফাই' },
  'Ready to check scholarship fit': { hi: 'छात्रवृत्ति फिट जांचने के लिए तैयार', bn: 'স্কলারশিপ ফিট যাচাই করতে প্রস্তুত' },
  'Open official portal': { hi: 'आधिकारिक पोर्टल खोलें', bn: 'অফিশিয়াল পোর্টাল খুলুন' },
  'Search official notice': { hi: 'आधिकारिक नोटिस खोजें', bn: 'অফিশিয়াল নোটিশ খুঁজুন' },
  'Notify me before deadline': { hi: 'डेडलाइन से पहले सूचित करें', bn: 'ডেডলাইনের আগে জানাও' },
  Overview: { hi: 'ओवरव्यू', bn: 'ওভারভিউ' },
  Eligibility: { hi: 'पात्रता', bn: 'যোগ্যতা' },
  Docs: { hi: 'दस्तावेज़', bn: 'ডকস' },
  Apply: { hi: 'आवेदन', bn: 'আবেদন' },
  'Eligibility report': { hi: 'पात्रता रिपोर्ट', bn: 'যোগ্যতা রিপোর্ট' },
  'Current blockers': { hi: 'मौजूदा बाधाएं', bn: 'বর্তমান বাধা' },
  'Documents checklist': { hi: 'दस्तावेज़ चेकलिस्ट', bn: 'ডকুমেন্ট চেকলিস্ট' },
  Missing: { hi: 'कम है', bn: 'অনুপস্থিত' },
  Ready: { hi: 'तैयार', bn: 'প্রস্তুত' },
  'Apply from official portal': { hi: 'आधिकारिक पोर्टल से आवेदन करें', bn: 'অফিশিয়াল পোর্টাল থেকে আবেদন করুন' },
  'Application steps': { hi: 'आवेदन के चरण', bn: 'আবেদনের ধাপ' },
  'Next best move': { hi: 'अगला सबसे अच्छा कदम', bn: 'পরবর্তী সেরা পদক্ষেপ' },

  'Chat History': { hi: 'चैट इतिहास', bn: 'চ্যাট ইতিহাস' },
  'No history': { hi: 'कोई इतिहास नहीं', bn: 'কোনো ইতিহাস নেই' },
  'No chat history yet': { hi: 'अभी कोई चैट इतिहास नहीं', bn: 'এখনও কোনো চ্যাট ইতিহাস নেই' },
  'New Chat': { hi: 'नई चैट', bn: 'নতুন চ্যাট' },
  'Delete this chat?': { hi: 'यह चैट हटाएं?', bn: 'এই চ্যাট মুছবেন?' },

  'People building the platform': { hi: 'प्लेटफॉर्म बनाने वाली टीम', bn: 'প্ল্যাটফর্ম তৈরির মানুষজন' },
  'A focused view of roles, strengths, motivations, and working styles behind Potho-Prodorshok.': {
    hi: 'Potho-Prodorshok के पीछे भूमिकाओं, ताकतों, प्रेरणाओं और काम करने के तरीकों का केंद्रित दृश्य।',
    bn: 'Potho-Prodorshok-এর পেছনের ভূমিকা, শক্তি, প্রেরণা এবং কাজের ধরনগুলির ফোকাসড ভিউ।',
  },
  Bio: { hi: 'परिचय', bn: 'বায়ো' },
  Goals: { hi: 'लक्ष्य', bn: 'লক্ষ্য' },
  Motivations: { hi: 'प्रेरणाएं', bn: 'প্রেরণা' },
  'Working Style': { hi: 'कार्य शैली', bn: 'কাজের ধরন' },
  'Friction Points': { hi: 'समस्या बिंदु', bn: 'সমস্যার পয়েন্ট' },
  Personality: { hi: 'व्यक्तित्व', bn: 'ব্যক্তিত্ব' },

  'Potho Prodorshok logo': { hi: 'Potho Prodorshok लोगो', bn: 'Potho Prodorshok লোগো' },
  English: { hi: 'अंग्रेज़ी', bn: 'ইংরেজি' },
  Hindi: { hi: 'हिंदी', bn: 'হিন্দি' },
  Bengali: { hi: 'बंगाली', bn: 'বাংলা' },
  Yes: { hi: 'हाँ', bn: 'হ্যাঁ' },
  No: { hi: 'नहीं', bn: 'না' },
  'Prefer not to say': { hi: 'बताना नहीं चाहते', bn: 'বলতে চাই না' },
  'B.Tech CSE, MBBS, Class 12 Science...': { hi: 'B.Tech CSE, MBBS, कक्षा 12 विज्ञान...', bn: 'B.Tech CSE, MBBS, ক্লাস 12 বিজ্ঞান...' },
  India: { hi: 'भारत', bn: 'ভারত' },
  Optional: { hi: 'वैकल्पिक', bn: 'ঐচ্ছিক' },
  'Class 12th student, graduate, dropper...': { hi: 'कक्षा 12 का छात्र, स्नातक, ड्रॉपर...', bn: 'ক্লাস 12-এর ছাত্র, গ্র্যাজুয়েট, ড্রপার...' },
  'Science, commerce, B.Tech, BA...': { hi: 'विज्ञान, कॉमर्स, B.Tech, BA...', bn: 'বিজ্ঞান, কমার্স, B.Tech, BA...' },
  'CIL, GATE, JEE, NEET, UPSC...': { hi: 'CIL, GATE, JEE, NEET, UPSC...', bn: 'CIL, GATE, JEE, NEET, UPSC...' },
  'Computer networks, DBMS, aptitude...': { hi: 'कंप्यूटर नेटवर्क, DBMS, एप्टीट्यूड...', bn: 'কম্পিউটার নেটওয়ার্ক, DBMS, অ্যাপ্টিটিউড...' },
  'West Bengal, India': { hi: 'पश्चिम बंगाल, भारत', bn: 'পশ্চিমবঙ্গ, ভারত' },
  'West Bengal': { hi: 'पश्चिम बंगाल', bn: 'পশ্চিমবঙ্গ' },
  'e.g. 350000': { hi: 'जैसे 350000', bn: 'যেমন 350000' },
  'College, school, university...': { hi: 'कॉलेज, स्कूल, विश्वविद्यालय...', bn: 'কলেজ, স্কুল, বিশ্ববিদ্যালয়...' },
  'School, college, university...': { hi: 'स्कूल, कॉलेज, विश्वविद्यालय...', bn: 'স্কুল, কলেজ, বিশ্ববিদ্যালয়...' },
  '1st year, final year, postgraduate...': { hi: 'पहला वर्ष, अंतिम वर्ष, पोस्टग्रेजुएट...', bn: 'প্রথম বর্ষ, ফাইনাল ইয়ার, পোস্টগ্র্যাজুয়েট...' },
  'Python, communication, lab research...': { hi: 'Python, संचार, लैब रिसर्च...', bn: 'Python, যোগাযোগ, ল্যাব রিসার্চ...' },
  'Machine learning, biology, design...': { hi: 'मशीन लर्निंग, बायोलॉजी, डिज़ाइन...', bn: 'মেশিন লার্নিং, বায়োলজি, ডিজাইন...' },
  'Doctor, IAS officer, software engineer...': { hi: 'डॉक्टर, IAS अधिकारी, सॉफ्टवेयर इंजीनियर...', bn: 'ডাক্তার, IAS অফিসার, সফটওয়্যার ইঞ্জিনিয়ার...' },
  'IIT, Google, government service...': { hi: 'IIT, Google, सरकारी सेवा...', bn: 'IIT, Google, সরকারি চাকরি...' },

  'Roadmap Canvas': { hi: 'रोडमैप कैनवास', bn: 'রোডম্যাপ ক্যানভাস' },
  Archive: { hi: 'आर्काइव', bn: 'আর্কাইভ' },
  'Open planner': { hi: 'प्लानर खोलें', bn: 'প্ল্যানার খুলুন' },
  'Open AI tutor': { hi: 'AI ट्यूटर खोलें', bn: 'AI টিউটর খুলুন' },
  'Test Analytics': { hi: 'टेस्ट एनालिटिक्स', bn: 'টেস্ট অ্যানালিটিক্স' },
  'AI Career Advisor': { hi: 'AI करियर सलाहकार', bn: 'AI ক্যারিয়ার অ্যাডভাইজার' },
  'Awaiting Input': { hi: 'इनपुट की प्रतीक्षा', bn: 'ইনপুটের অপেক্ষা' },
  'Plan intelligence': { hi: 'योजना बुद्धिमत्ता', bn: 'প্ল্যান ইন্টেলিজেন্স' },
  'Profile completeness': { hi: 'प्रोफाइल पूर्णता', bn: 'প্রোফাইল সম্পূর্ণতা' },
  'Generated steps': { hi: 'जनरेट किए गए चरण', bn: 'তৈরি ধাপ' },
  'Next action': { hi: 'अगला कदम', bn: 'পরবর্তী কাজ' },
  'Complete the profile and generate your first roadmap.': { hi: 'प्रोफाइल पूरी करें और पहला रोडमैप जनरेट करें।', bn: 'প্রোফাইল সম্পূর্ণ করুন এবং প্রথম রোডম্যাপ তৈরি করুন।' },
  'Not started': { hi: 'शुरू नहीं हुआ', bn: 'শুরু হয়নি' },
  'In progress': { hi: 'चल रहा है', bn: 'চলছে' },
  Done: { hi: 'पूरा', bn: 'সম্পন্ন' },
  'Add a note, link, or next action': { hi: 'नोट, लिंक या अगला कदम जोड़ें', bn: 'নোট, লিংক বা পরবর্তী কাজ যোগ করুন' },

  'AI report + learning graph': { hi: 'AI रिपोर्ट + लर्निंग ग्राफ', bn: 'AI রিপোর্ট + লার্নিং গ্রাফ' },
  Best: { hi: 'सबसे अच्छा', bn: 'সেরা' },
  Weakest: { hi: 'सबसे कमजोर', bn: 'সবচেয়ে দুর্বল' },
  Trend: { hi: 'रुझान', bn: 'ট্রেন্ড' },
  'due today': { hi: 'आज देय', bn: 'আজ বাকি' },
  overdue: { hi: 'समय से बाहर', bn: 'ওভারডিউ' },
  wrong: { hi: 'गलत', bn: 'ভুল' },
  mastered: { hi: 'मास्टर्ड', bn: 'আয়ত্ত' },
  'Start review': { hi: 'रिव्यू शुरू करें', bn: 'রিভিউ শুরু করুন' },
  'Mock snapshot': { hi: 'मॉक स्नैपशॉट', bn: 'মক স্ন্যাপশট' },
  Average: { hi: 'औसत', bn: 'গড়' },
  Latest: { hi: 'नवीनतम', bn: 'সর্বশেষ' },
  'Open full analysis': { hi: 'पूरा विश्लेषण खोलें', bn: 'পূর্ণ বিশ্লেষণ খুলুন' },
  'Try the workspace with sample data. Sign up to save roadmaps, mock results, questions, and profile memory.': {
    hi: 'सैंपल डेटा के साथ कार्यक्षेत्र आज़माएं। रोडमैप, मॉक परिणाम, प्रश्न और प्रोफाइल मेमोरी सेव करने के लिए साइन अप करें।',
    bn: 'স্যাম্পল ডেটা দিয়ে কর্মক্ষেত্রটি ব্যবহার করে দেখুন। রোডম্যাপ, মক ফলাফল, প্রশ্ন এবং প্রোফাইল মেমরি সংরক্ষণ করতে সাইন আপ করুন।',
  },
  'Save my workspace': { hi: 'मेरा कार्यक्षेत्र सेव करें', bn: 'আমার কর্মক্ষেত্র সংরক্ষণ করুন' },
  "Today's next action": { hi: 'आज का अगला कदम', bn: 'আজকের পরবর্তী কাজ' },
  'Saved library': { hi: 'सेव लाइब्रेरी', bn: 'সংরক্ষিত লাইব্রেরি' },
  'Practice / revision queue': { hi: 'प्रैक्टिस / रिविजन कतार', bn: 'প্র্যাকটিস / রিভিশন কিউ' },
  'Career path': { hi: 'करियर पथ', bn: 'ক্যারিয়ার পথ' },
  'Study timer': { hi: 'स्टडी टाइमर', bn: 'স্টাডি টাইমার' },
  'Scholarship and deadline signals': { hi: 'छात्रवृत्ति और डेडलाइन संकेत', bn: 'স্কলারশিপ ও ডেডলাইন সিগন্যাল' },
  'Find scholarships based on your profile': { hi: 'अपनी प्रोफाइल के आधार पर छात्रवृत्ति खोजें', bn: 'আপনার প্রোফাইল অনুযায়ী স্কলারশিপ খুঁজুন' },
  'AI tutor and chat': { hi: 'AI ट्यूटर और चैट', bn: 'AI টিউটর ও চ্যাট' },
  'Saved questions': { hi: 'सेव प्रश्न', bn: 'সংরক্ষিত প্রশ্ন' },
  'Recent activity': { hi: 'हाल की गतिविधि', bn: 'সাম্প্রতিক কার্যকলাপ' },
  'Generate a roadmap, answer questions, or save scholarships to build your activity trail.': {
    hi: 'अपनी गतिविधि ट्रेल बनाने के लिए रोडमैप जनरेट करें, प्रश्न हल करें या छात्रवृत्ति सेव करें।',
    bn: 'আপনার অ্যাক্টিভিটি ট্রেইল তৈরি করতে রোডম্যাপ তৈরি করুন, প্রশ্নের উত্তর দিন বা স্কলারশিপ সংরক্ষণ করুন।',
  },
  'Today studied:': { hi: 'आज पढ़ाई:', bn: 'আজ পড়া হয়েছে:' },
  'Topic or roadmap step': { hi: 'विषय या रोडमैप चरण', bn: 'বিষয় বা রোডম্যাপ ধাপ' },
  'Timer minutes': { hi: 'टाइमर मिनट', bn: 'টাইমার মিনিট' },
  'Save time': { hi: 'समय सेव करें', bn: 'সময় সংরক্ষণ' },
  Reset: { hi: 'रीसेट', bn: 'রিসেট' },

  'Nothing saved yet': { hi: 'अभी कुछ सेव नहीं', bn: 'এখনও কিছু সংরক্ষিত নেই' },
  'Open full review': { hi: 'पूरा रिव्यू खोलें', bn: 'পূর্ণ রিভিউ খুলুন' },
  shortlisted: { hi: 'शॉर्टलिस्ट', bn: 'শর্টলিস্টেড' },
  applying: { hi: 'आवेदन कर रहे हैं', bn: 'আবেদন চলছে' },
  applied: { hi: 'आवेदन किया', bn: 'আবেদন করা হয়েছে' },
  closed: { hi: 'बंद', bn: 'বন্ধ' },
  'Resource title': { hi: 'रिसोर्स शीर्षक', bn: 'রিসোর্স শিরোনাম' },
  'Link, PDF, video, article': { hi: 'लिंक, PDF, वीडियो, लेख', bn: 'লিংক, PDF, ভিডিও, আর্টিকেল' },
  'Topic tag': { hi: 'विषय टैग', bn: 'বিষয় ট্যাগ' },
  'Open resource': { hi: 'रिसोर्स खोलें', bn: 'রিসোর্স খুলুন' },
  'Saved Library': { hi: 'सेव लाइब्रेरी', bn: 'সংরক্ষিত লাইব্রেরি' },
  'Everything you have built': { hi: 'जो कुछ आपने बनाया है', bn: 'আপনি যা তৈরি করেছেন' },
  'Roadmaps, questions, mocks, scholarships, resources, and chats stay organized as searchable workspace objects.': {
    hi: 'रोडमैप, प्रश्न, मॉक, छात्रवृत्ति, रिसोर्स और चैट खोजने योग्य कार्यक्षेत्र आइटम के रूप में व्यवस्थित रहते हैं।',
    bn: 'রোডম্যাপ, প্রশ্ন, মক, স্কলারশিপ, রিসোর্স এবং চ্যাট সার্চযোগ্য কর্মক্ষেত্র অবজেক্ট হিসেবে সাজানো থাকে।',
  },
  Plans: { hi: 'योजनाएं', bn: 'প্ল্যান' },
  Practice: { hi: 'प्रैक्टिस', bn: 'প্র্যাকটিস' },
  Mocks: { hi: 'मॉक', bn: 'মক' },
  'Current view': { hi: 'वर्तमान दृश्य', bn: 'বর্তমান ভিউ' },
  'Mock test review': { hi: 'मॉक टेस्ट रिव्यू', bn: 'মক টেস্ট রিভিউ' },
  Correct: { hi: 'सही', bn: 'সঠিক' },
  Incorrect: { hi: 'गलत', bn: 'ভুল' },
  Questions: { hi: 'प्रश्न', bn: 'প্রশ্ন' },
  'Your answer:': { hi: 'आपका उत्तर:', bn: 'আপনার উত্তর:' },
  'Correct answer:': { hi: 'सही उत्तर:', bn: 'সঠিক উত্তর:' },

  'Action plan': { hi: 'कार्य योजना', bn: 'অ্যাকশন প্ল্যান' },
  'Completion checklist': { hi: 'पूर्णता चेकलिस्ट', bn: 'সম্পূর্ণতার চেকলিস্ট' },
  Deliverable: { hi: 'डिलिवरेबल', bn: 'ডেলিভারেবল' },
  'Generate a structured guide for this stage': { hi: 'इस चरण के लिए संरचित गाइड बनाएं', bn: 'এই ধাপের জন্য গঠিত গাইড তৈরি করুন' },
  'The AI guide will be saved back into this roadmap stage so you can return to it from the dashboard or library.': {
    hi: 'AI गाइड इसी रोडमैप चरण में सेव होगी ताकि आप डैशबोर्ड या लाइब्रेरी से वापस आ सकें।',
    bn: 'AI গাইডটি এই রোডম্যাপ ধাপে সংরক্ষিত থাকবে, যাতে ড্যাশবোর্ড বা লাইব্রেরি থেকে ফিরে আসতে পারেন।',
  },
  'Stage resources': { hi: 'चरण रिसोर्स', bn: 'ধাপের রিসোর্স' },
  'AI suggested resources': { hi: 'AI सुझाए गए रिसोर्स', bn: 'AI প্রস্তাবিত রিসোর্স' },
  'Ask AI next': { hi: 'अगला AI से पूछें', bn: 'পরেরটি AI-কে জিজ্ঞেস করুন' },

  'Privacy Policy and Terms | Potho-Prodorshok': { hi: 'गोपनीयता नीति और शर्तें | Potho-Prodorshok', bn: 'প্রাইভেসি পলিসি ও শর্তাবলি | Potho-Prodorshok' },
  'Privacy, data, and terms': { hi: 'गोपनीयता, डेटा और शर्तें', bn: 'প্রাইভেসি, ডেটা ও শর্তাবলি' },
  'What we collect': { hi: 'हम क्या एकत्र करते हैं', bn: 'আমরা কী সংগ্রহ করি' },
  'How AI features use data': { hi: 'AI फीचर डेटा कैसे उपयोग करते हैं', bn: 'AI ফিচার কীভাবে ডেটা ব্যবহার করে' },
  'How we use data': { hi: 'हम डेटा कैसे उपयोग करते हैं', bn: 'আমরা কীভাবে ডেটা ব্যবহার করি' },
  'Security and storage': { hi: 'सुरक्षा और स्टोरेज', bn: 'নিরাপত্তা ও সংরক্ষণ' },
  'User control': { hi: 'उपयोगकर्ता नियंत्रण', bn: 'ব্যবহারকারীর নিয়ন্ত্রণ' },
  'Terms of use': { hi: 'उपयोग की शर्तें', bn: 'ব্যবহারের শর্তাবলি' },
  'Quick summary': { hi: 'त्वरित सारांश', bn: 'দ্রুত সারাংশ' },
  'Support and FAQ | Potho-Prodorshok': { hi: 'सहायता और FAQ | Potho-Prodorshok', bn: 'সাপোর্ট ও FAQ | Potho-Prodorshok' },
  'Help and contact': { hi: 'मदद और संपर्क', bn: 'সহায়তা ও যোগাযোগ' },
  'Frequently asked questions': { hi: 'अक्सर पूछे जाने वाले प्रश्न', bn: 'প্রায়শই জিজ্ঞাসিত প্রশ্ন' },
  Contact: { hi: 'संपर्क', bn: 'যোগাযোগ' },
  Message: { hi: 'संदेश', bn: 'বার্তা' },
  'Send message': { hi: 'संदेश भेजें', bn: 'বার্তা পাঠান' },
  'Data requests': { hi: 'डेटा अनुरोध', bn: 'ডেটা অনুরোধ' },
  'Bug reports': { hi: 'बग रिपोर्ट', bn: 'বাগ রিপোর্ট' },
  'Thank You!': { hi: 'धन्यवाद!', bn: 'ধন্যবাদ!' },
  'Your message has been sent successfully.': { hi: 'आपका संदेश सफलतापूर्वक भेज दिया गया है।', bn: 'আপনার বার্তা সফলভাবে পাঠানো হয়েছে।' },
  'You sent:': { hi: 'आपने भेजा:', bn: 'আপনি পাঠিয়েছেন:' },

  'No match breakdown returned. Add more profile details and search again.': {
    hi: 'मैच ब्रेकडाउन नहीं मिला। अधिक प्रोफाइल विवरण जोड़ें और फिर खोजें।',
    bn: 'ম্যাচ ব্রেকডাউন পাওয়া যায়নি। আরও প্রোফাইল তথ্য যোগ করে আবার খুঁজুন।',
  },
  'Document list was not returned. Check the official notice before applying.': {
    hi: 'दस्तावेज़ सूची नहीं मिली। आवेदन से पहले आधिकारिक नोटिस देखें।',
    bn: 'ডকুমেন্ট তালিকা পাওয়া যায়নি। আবেদন করার আগে অফিশিয়াল নোটিশ দেখুন।',
  },
  Income: { hi: 'आय', bn: 'আয়' },
  Destination: { hi: 'गंतव्य', bn: 'গন্তব্য' },
  'Docs ready': { hi: 'दस्तावेज़ तैयार', bn: 'ডকস প্রস্তুত' },
  'Selected scholarship': { hi: 'चयनित छात्रवृत्ति', bn: 'নির্বাচিত স্কলারশিপ' },
  'Open the full page for amount basis, document checklist, eligibility blockers, and clickable portal steps.': {
    hi: 'राशि आधार, दस्तावेज़ चेकलिस्ट, पात्रता बाधाएं और क्लिक करने योग्य पोर्टल चरणों के लिए पूरा पेज खोलें।',
    bn: 'পরিমাণের ভিত্তি, ডকুমেন্ট চেকলিস্ট, যোগ্যতার বাধা এবং ক্লিকযোগ্য পোর্টাল ধাপের জন্য পূর্ণ পেজ খুলুন।',
  },
  'Scholarship smart bot': { hi: 'छात्रवृत्ति स्मार्ट बॉट', bn: 'স্কলারশিপ স্মার্ট বট' },
  'Am I eligible? Why not? Deadline?': { hi: 'क्या मैं पात्र हूं? क्यों नहीं? डेडलाइन?', bn: 'আমি কি যোগ্য? কেন নয়? ডেডলাইন?' },
  Ask: { hi: 'पूछें', bn: 'জিজ্ঞেস করুন' },
  'Select a scholarship to ask eligibility questions.': { hi: 'पात्रता प्रश्न पूछने के लिए छात्रवृत्ति चुनें।', bn: 'যোগ্যতা নিয়ে প্রশ্ন করতে একটি স্কলারশিপ নির্বাচন করুন।' },
};

const trackedAttributes = ['placeholder', 'aria-label', 'title', 'alt'];
const originalText = new WeakMap();
const originalAttributes = new WeakMap();

const normalize = (value) => String(value || '').replace(/\s+/g, ' ').trim();

const basePhraseFor = (value) => {
  const normalized = normalize(value);
  if (!normalized) return normalized;
  if (phraseTranslations[normalized]) return normalized;
  for (const [phrase, translations] of Object.entries(phraseTranslations)) {
    if (normalize(translations.hi) === normalized || normalize(translations.bn) === normalized) return phrase;
  }
  return normalized;
};

const translateValue = (value, language) => {
  const lang = String(language || 'en').slice(0, 2).toLowerCase();
  const basePhrase = basePhraseFor(value);
  if (lang === 'en') {
    const normalized = normalize(value);
    return normalized && basePhrase !== normalized ? String(value).replace(normalized, basePhrase) : value;
  }
  const exact = phraseTranslations[basePhrase]?.[lang];
  if (exact) return exact;
  return phraseTranslations[normalize(value)]?.[lang] || value;
};

const translateTextNode = (node, language) => {
  const current = node.nodeValue;
  const storedBase = originalText.get(node);
  let base = storedBase ?? current;
  if (!normalize(base)) return;

  if (storedBase) {
    const baseNeedle = normalize(storedBase);
    const expectedTranslation = translateValue(baseNeedle, language);
    const expectedValue = storedBase.replace(baseNeedle, expectedTranslation);
    const currentNormalized = normalize(current);
    const expectedNormalized = normalize(expectedValue);
    const storedNormalized = normalize(storedBase);

    if (currentNormalized && currentNormalized !== expectedNormalized && currentNormalized !== storedNormalized) {
      base = current;
      originalText.set(node, current);
    }
  } else {
    originalText.set(node, current);
  }

  const translated = translateValue(normalize(base), language);
  node.nodeValue = base.replace(normalize(base), translated);
};

const translateAttributes = (element, language) => {
  if (!originalAttributes.has(element)) originalAttributes.set(element, {});
  const originals = originalAttributes.get(element);
  trackedAttributes.forEach((attribute) => {
    if (!element.hasAttribute(attribute)) return;
    if (!originals[attribute]) originals[attribute] = element.getAttribute(attribute);
    const translated = translateValue(originals[attribute], language);
    if (element.getAttribute(attribute) !== translated) element.setAttribute(attribute, translated);
  });
};

const walk = (root, language) => {
  if (!root) return;
  if (root.nodeType === Node.TEXT_NODE) {
    translateTextNode(root, language);
    return;
  }
  if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE) return;
  const element = root.nodeType === Node.ELEMENT_NODE ? root : null;
  if (element && ['SCRIPT', 'STYLE', 'TEXTAREA', 'CODE', 'PRE'].includes(element.tagName)) return;
  if (element) translateAttributes(element, language);
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT, {
    acceptNode(node) {
      if (node.nodeType === Node.ELEMENT_NODE && ['SCRIPT', 'STYLE', 'TEXTAREA', 'CODE', 'PRE'].includes(node.tagName)) {
        return NodeFilter.FILTER_REJECT;
      }
      return NodeFilter.FILTER_ACCEPT;
    },
  });
  let node = walker.nextNode();
  while (node) {
    if (node.nodeType === Node.TEXT_NODE) translateTextNode(node, language);
    if (node.nodeType === Node.ELEMENT_NODE) translateAttributes(node, language);
    node = walker.nextNode();
  }
};

const translateDocumentMetadata = (language) => {
  if (document.title) {
    const nextTitle = translateValue(document.title, language);
    if (document.title !== nextTitle) document.title = nextTitle;
  }

  [
    'meta[name="description"]',
    'meta[property="og:title"]',
    'meta[property="og:description"]',
    'meta[name="twitter:title"]',
    'meta[name="twitter:description"]',
  ].forEach((selector) => {
    const element = document.querySelector(selector);
    if (!element?.content) return;
    const nextContent = translateValue(element.content, language);
    if (element.content !== nextContent) element.content = nextContent;
  });
};

export const applyDomTranslations = (language) => {
  if (typeof document === 'undefined') return;
  translateDocumentMetadata(language);
  walk(document.body, language);
};

export const startDomTranslations = (getLanguage) => {
  if (typeof document === 'undefined' || !document.body) return () => {};
  let frame = 0;
  const schedule = () => {
    if (frame) return;
    frame = window.requestAnimationFrame(() => {
      frame = 0;
      applyDomTranslations(getLanguage());
    });
  };
  const observer = new MutationObserver(schedule);
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: trackedAttributes,
  });
  schedule();
  return () => {
    observer.disconnect();
    if (frame) window.cancelAnimationFrame(frame);
  };
};
